export const POSITION_PROPERTY = {
    top: 'nextElementSibling',
    bottom: 'previousElementSibling',
};
